export default __webpack_public_path__ + "media/images/images/backgrounds/bg-11-9a45dd0143014986eb3e825c9bedd2a1.jpg";